
    import "src/app/Auth/SignUp/index.module.scss?farm_css_modules";
    
    export default {"leftComponent": `leftComponent-01294988`,"leftTitle": `leftTitle-01294988`,"loginComponent": `loginComponent-01294988`,"profileFormContainer": `profileFormContainer-01294988`,"signupContainer": `signupContainer-01294988`,"subTitle": `subTitle-01294988`,"title": `title-01294988`,"topImage": `topImage-01294988`,"topLogoImage": `topLogoImage-01294988`}
    